import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or a Supabase anon key (VITE_SUPABASE_ANON_KEY or VITE_SUPABASE_PUBLISHABLE_KEY). Set them in your environment (e.g. .env.local).'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Use singleton pattern to prevent multiple instances
let supabaseInstance: ReturnType<typeof createClient<Database>> | null = null

export const supabase = (() => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      global: {
        headers: {
          apikey: SUPABASE_PUBLISHABLE_KEY,
        },
      },
      auth: {
        persistSession: true,
        storageKey: 'supabase.auth.token',
        detectSessionInUrl: true,
      },
    })
  }
  return supabaseInstance
})()
